import * as React from "react";

import connectToList from "../../store/list";

import GenControlsBar from "../Gen/ControlsBar";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";
import VersionSummary from "./Summary";

interface VersionListProps {
  documentId: number;
  versions: ConnectedList<VersionSnakeModel>;
}

function VersionList(props: VersionListProps) {
  const {
    documentId,
    versions,
  } = props;

  React.useEffect(() => {
    versions.mountList(`/documents/${documentId}/versions`);
  }, []);

  return (
    <div>
      <GenControlsBar>
        <GenSearchBox
          {...versions}
        />
      </GenControlsBar>
      {versions.listData?.map((version) => (
        <VersionSummary
          key={version.id}
          version={version}
        />
      ))}
      <GenMore
        {...versions}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(VersionList, ["versions"]);
